<template>
<vx-card fixed-height="true">
    <vs-row>
        <!-- {{ nuevoarray }} -->
        <vs-divider>Búsqueda de Institución o Punto de Venta</vs-divider>
        <!-- <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center;"><b>Información</b></vs-col> -->
        <br>
        <vs-row>
            <!-- {{ nuevoarray }} -->
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <!-- {{ idmovimiento }} -->
                <!-- {{ infoPedido.libro }} hola -->
                <!-- <v-select :options="arregloLibros" :reduce="arregloLibros => arregloLibros.nombrelibro" label="nombrelibro" class="w-full h-100" placeholder="--Seleccione un texto--" v-model="infoPedido.libro" /> -->
                <vs-row vs-justify="center" vs-w="12">
                    <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                        <div align="center">
                            <table>
                                <tr>
                                    <td width="500">
                                        <vs-input label="Busque la Institución o punto de venta" placeholder="Filtre por código o nombre" icon="search" class="w-full mt-5" @keyup.enter="getInstitucionesAsignar()" v-model="filtrocodnombre" ref="filtroinspunto" :class="classvalidarinstitucion" />
                                        <small class="mt-2" v-if="encontroresultados == 1"><span class="text-warning">El producto no existe.</span></small>
                                    </td>
                                    <td width="200">
                                        <vs-button @click="getInstitucionesAsignar()" style="margin-top: 36px;" color="success" type="relief">Buscar</vs-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" v-if="InstitucionesBusqueda.length > 0">
                        <vs-divider>Selección de Institución o Punto de Venta</vs-divider>
                        <vs-table max-items="5" search pagination :data="InstitucionesBusqueda">
                            <template slot="thead">
                                <vs-th>Institución/Punto de venta</vs-th>
                                <vs-th>Ciudad</vs-th>
                                <!-- <vs-th>Asesor</vs-th> -->
                                <vs-th>Acciones</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                        {{data[indextr].nombreInstitucion}}<br>
                                    </vs-td>
                                    <vs-td>
                                        {{data[indextr].ciudad}}<br>
                                    </vs-td>
                                    <!-- <vs-td>
                                        {{data[indextr].asesor}}<br>
                                    </vs-td> -->
                                    <vs-td>
                                        <div style="display: flex;">
                                            <div>
                                                <vx-tooltip style="display: inline-block;" text="Asignar beneficiario" position="top" color="primary">
                                                    <vs-button class="modal-default-button" size="small" color="success" type="filled" @click="seleccionInstitucion(tr)" icon-pack="feather" icon="icon-check">Seleccionar</vs-button>
                                                </vx-tooltip> &nbsp;
                                            </div>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <vs-divider>Información</vs-divider>
        <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
                    <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                    <!-- <vs-input label="Nombre Institución " placeholder="Nombre Institución" class="w-full" icon="mode_edit" v-model="nuevoarray.nombreInstitucion" /> -->
                    <div style="position: relative; width: 100%;" @click="validarinsvacio">
                        <vs-textarea style="width:100%;" label="Institución/Punto de venta" v-model="nombreciudadins" disabled />
                        <span style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></span>
                    </div>
                </vs-col>
            </vs-row>
        </vs-col>
        <vs-row vs-align="center">

            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="8">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Crédito General [18(enteros),2(decimales)]" placeholder="Crédito General" class="w-full" icon="mode_edit" v-model="nuevoarray.ffp_credito" @keypress="validarCredito($event)" @paste="validarnopegar($event)" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="8">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Cúpo Inicial [18(enteros),2(decimales)]" placeholder="Cúpo Inicial" class="w-full" icon="mode_edit" v-model="nuevoarray.ffp_cupo" @keypress="validarCupo($event)" @paste="validarnopegar($event)" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-row vs-align="center" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="8">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Descuento en porcentaje [3(enteros)]" placeholder="Descuento" class="w-full" icon="mode_edit" v-model="nuevoarray.ffp_descuento" @keypress="validarDescuento($event)" @paste="validarnopegar($event)" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </vs-row>
    <br><br>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
        <vs-button @click="guardarnuevoeditarFormularioProforma()" type="relief">Guardar</vs-button>&emsp;
        <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
    </vs-col>
    <br>
    <br>
</vx-card>
</template>

<script>
import {
    mapState
} from "vuex";
import vSelect from "vue-select";
export default {
    data() {
        return {
            Verificacionconteo: '',
            UsuariosLibrerias: [],
            ContratoAgrupacion: [],
            ffp_id: 0,
            nuevoarray: {},
            filtrocodnombre: '',
            encontroresultados: 0,
            InstitucionesBusqueda: [],
            classvalidarinstitucion: '',
            nombreciudadins: '',
            //showAgregarNuevo: false,
        };
    },
    components: {
        "v-select": vSelect,
    },
    props: {
        verificarcrear_actualizar: {
            type: String,
            default: '',
        },
        tabFormularioProforma: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },
    mounted() {
        let me = this;
        if (me.verificarcrear_actualizar === 'create') {
            const proformasxperiodo = localStorage.getItem('pid');
            const usuariorespo = localStorage.getItem("usuario");
            const usuarioObjeto = JSON.parse(usuariorespo);
            me.nuevoarray = {
                idInstitucion: 0,
                idperiodoescolar: proformasxperiodo,
                ffp_credito: '',
                ffp_cupo: '',
                ffp_descuento: '',
                nombreInstitucion: '',
                ciudad: '',
                user_created: usuarioObjeto.idusuario,
            };
            // me.getNuevoContUserAgrupacion();
        } else if (me.verificarcrear_actualizar === 'update') {
            // console.log("Entro en actualizar");
            me.nuevoarray = me.tabFormularioProforma;
            me.nombreciudadins = me.nuevoarray.nombreInstitucion + ' | Ciudad: ' +me.nuevoarray.ciudad;
        } else {
            console.log("Validación no controlada");
        }
    },
    computed: {
        ...mapState(["auth", 'userRoot', 'susuario', 'userAsesor', 'AdminBodega']),
    },
    methods: {
        //SECCION GUARDAR NUEVO PRODUCTO
        // getNuevoContUserAgrupacion() {
        //     this.nuevoarray.ca_id = ''
        //     this.nuevoarray.idusuario = ''
        // },
        validarCredito(event) {
            let credito = this.nuevoarray.ffp_credito;
            // Verificar si la tecla presionada es un número
            if (!/\d|\.|,/.test(event.key)) {
                event.preventDefault();
                return;
            }
            // Reemplazar comas por puntos solo si hay comas en la cadena
            if (credito.includes(',')) {
                credito = credito.replace(',', '.');
                this.nuevoarray.ffp_credito = credito;
            }
            // Validar el formato del número
            if (!/^\d{0,18}(\.\d{0,2})?$/.test(credito)) {
                this.nuevoarray.ffp_credito = '';
                console.log("reset");
            }
        },
        validarCupo(event) {
            let cupo = this.nuevoarray.ffp_cupo;
            // Verificar si la tecla presionada es un número
            if (!/\d|\.|,/.test(event.key)) {
                event.preventDefault();
                return;
            }
            // Reemplazar comas por puntos solo si hay comas en la cadena
            if (cupo.includes(',')) {
                cupo = cupo.replace(',', '.');
                this.nuevoarray.ffp_cupo = cupo;
            }
            // Validar el formato del número
            if (!/^\d{0,18}(\.\d{0,2})?$/.test(cupo)) {
                this.nuevoarray.ffp_cupo = '';
                console.log("reset");
            }
        },
        validarDescuento(event) {
            let cupo = this.nuevoarray.ffp_descuento;
            // Verificar si la tecla presionada es un número
            if (!/\d|\.|,/.test(event.key)) {
                event.preventDefault();
                return;
            }
            // Validar el formato del número
            if (!/^\d{0,4}(\.\d{0,0})?$/.test(cupo)) {
                this.nuevoarray.ffp_descuento = '';
                console.log("reset");
            }
            // Validar que no se ingrese un número mayor a 100
            let enteredValue = parseFloat(event.target.value + event.key);
            let descuentomaximo = 100;
            if (enteredValue > descuentomaximo) {
                // console.log("uno", enteredValue)
                // console.log("dos", descuentomaximo)
                event.preventDefault();
                this.$vs.notify({
                    text: "El descuento no puede exceder el 100%",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-triangle",
                });
            }
        },
        validarnopegar(event) {
            // Obtener el texto pegado
            let pastedText = (event.clipboardData || window.clipboardData).getData('text');

            // Verificar si el texto pegado contiene solo números
            if (!/^\d+$/.test(pastedText)) {
                event.preventDefault();
                return;
            }
        },
        validarinsvacio() {
            if (this.nuevoarray.nombreInstitucion == "") {
                this.$vs.notify({
                    text: 'Debe realizar una búsqueda para completar este campo.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    time: 5000
                })
                this.validarcampoinstitucion();
                return false;
            }
        },
        validarcampoinstitucion() {
            const focusnombreInstitucion = this.$refs.filtroinspunto.$el.querySelector('input');
            focusnombreInstitucion.focus();
            this.classvalidarinstitucion = 'stylevalidar';

            // Quitar la clase después de la duración de la animación
            setTimeout(() => {
                this.classvalidarinstitucion = '';
            }, 1500); // Ajusta según la duración de tu animación
        },
        getInstitucionesAsignar() {
            let me = this;
            if (me.filtrocodnombre.trim().length <= 1) {
                me.$vs.notify({
                    text: 'La busqueda debe ser mayor a 1 caracter.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return false;
            }
            this.$vs.loading();
            this.$http.get(this.$server_url + "listaInsitucion?busqueda=" + this.filtrocodnombre)
                .then(res => {
                    this.InstitucionesBusqueda = res.data;
                    // this.arregloInstitucionAsignada = datos.map(libro => ({
                    //     pro_codigo: libro.pro_codigo,
                    //     nombrelibro: libro.pro_nombre,
                    // }));
                    // console.log(this.InstitucionesBusqueda.length, "arregloseleccion");
                    if (this.InstitucionesBusqueda.length <= 0) {
                        this.encontroresultados = 1
                    } else {
                        this.encontroresultados = 0;
                    }
                    this.$vs.loading.close();
                })
                .catch(error => {
                    console.error('Error al obtener libros:', error);
                    this.$vs.loading.close();
                });
        },
        seleccionInstitucion(tr) {
            // console.log(tr, "data recibida");
            // return
            this.nuevoarray.nombreInstitucion = tr.nombreInstitucion;
            this.nuevoarray.idInstitucion = tr.idInstitucion;
            this.nuevoarray.ciudad = tr.ciudad;
            this.nombreciudadins = this.nuevoarray.nombreInstitucion + ' | Ciudad: ' +this.nuevoarray.ciudad;
            this.filtrocodnombre = '';
            this.InstitucionesBusqueda = [];
        },
        guardarnuevoeditarFormularioProforma() {
            let me = this;
            //VALIDACION DE CAMPOS NULOS Y VACIOS
            if (this.nuevoarray.idInstitucion === '' || this.nuevoarray.idInstitucion === null || this.nuevoarray.idInstitucion === 0) {
                me.$vs.notify({
                    text: 'Seleccione una Institución antes de guardar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                this.validarcampoinstitucion();
                return;
            }
            me.$vs.loading()
            if (me.verificarcrear_actualizar === 'create') {
                // console.log("entro a crear");
                let datos = {
                    "idInstitucion": this.nuevoarray.idInstitucion,
                    "idperiodoescolar": this.nuevoarray.idperiodoescolar,
                    "ffp_credito": this.nuevoarray.ffp_credito,
                    "ffp_cupo": this.nuevoarray.ffp_cupo,
                    "ffp_descuento":this.nuevoarray.ffp_descuento,
                    "user_created": this.nuevoarray.user_created,
                }
                //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
                this.$http.post(this.$server_url + 'Post_Registrar_modificar_formularioProforma', datos)
                    .then(res => {
                        me.$vs.loading.close()
                        // this.getContUserAgrupacionParametro();
                        me.$vs.notify({
                            text: 'Formulario guardado con exito',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        me.$emit('change', {
                            verificacionemitsaveandedit: 1
                        });
                    })
                    .catch(function (error) {
                        me.$vs.loading.close();
                        if (error.response && error.response.status === 500 && error.response.data.message.includes('Duplicate entry')) {
                            // Capturamos el mensaje de error específico de duplicación
                            let errorMessage = 'No se puede guardar, ya existe un registro en este período con esta Institución/Punto de venta.';

                            // Notificamos al usuario del error
                            me.$vs.notify({
                                text: errorMessage,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x',
                                time: 7000
                            });
                        } else {
                            console.log(error + ' error');
                        }
                    });
            } else if (me.verificarcrear_actualizar === 'update') {
                // console.log("entro a actuyalizar");
                let datos = {
                    "ffp_id": this.nuevoarray.ffp_id,
                    "idInstitucion": this.nuevoarray.idInstitucion,
                    "idperiodoescolar": this.nuevoarray.idperiodoescolar,
                    "ffp_credito": this.nuevoarray.ffp_credito,
                    "ffp_cupo": this.nuevoarray.ffp_cupo,
                    "ffp_descuento": this.nuevoarray.ffp_descuento,
                }
                //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
                this.$http.post(this.$server_url + 'Post_Registrar_modificar_formularioProforma', datos)
                    .then(res => {
                        me.$vs.loading.close()
                        // this.getContUserAgrupacionParametro();
                        me.$vs.notify({
                            text: 'Formulario editado con exito',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        me.$emit('change', {
                            verificacionemitsaveandedit: 1
                        });
                    })
                    .catch(function (error) {
                        me.$vs.loading.close();
                        if (error.response && error.response.status === 500 && error.response.data.message.includes('Duplicate entry')) {
                            // Capturamos el mensaje de error específico de duplicación
                            let errorMessage = 'No se puede guardar, ya existe un registro en este período con esta Institución/Punto de venta.';

                            // Notificamos al usuario del error
                            me.$vs.notify({
                                text: errorMessage,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x',
                                time: 7000
                            });
                        } else {
                            console.log(error + ' error');
                        }
                    });
            } else {
                console.log("Guardado no controlado");
            }
        },
        getCancelar() {
            this.$emit('change', {
                verificacionemitsaveandedit: 2
            });
        },
    },
};
</script>

<style scoped>
.stylevalidar {
    /* border: 2px solid #00f; */
    box-shadow: 0px 0px 2px 4px #ff0000;
    border-radius: 5px;
}
</style>
